import { ChertoExperiments } from 'constants/experiments'
import useExperiment from 'hooks/Experiments/useExperiment'

const INCLUDE_ALL_TRAFFIC_SOURCES = { overrideTrigger: true }

export function useFlashOfferLosCalendarExperimentState(canActivate = false) {
  const { isAnyVariant, variation } = useExperiment(
    ChertoExperiments.croFlashOfferLosCalendar,
    {
      canActivate,
      ...INCLUDE_ALL_TRAFFIC_SOURCES,
    },
  )

  return {
    /** Assigned variation. This stays true for Charter offers and does not mean the calendar should change. */
    isVariant: isAnyVariant,
    variation,
  }
}

function useFlashOfferLosCalendarExperiment(canActivate = false): boolean {
  return useFlashOfferLosCalendarExperimentState(canActivate).isVariant
}

export default useFlashOfferLosCalendarExperiment
